import { TextField as MTextField, TextFieldProps } from '@mui/material'
import useTextStyles from 'styles/useTextStyles'

export type { TextFieldProps }

export const TextField: React.FC<TextFieldProps> = (props) => {
  return (
    <MTextField
      {...props}
      InputProps={{
        style: {
          ...useTextStyles.bodyLarge,
          ...(props.InputProps?.style || {})
        },
        startAdornment: props.InputProps?.startAdornment,
        ...props.InputProps
      }}
      InputLabelProps={{
        style: {
          fontWeight: 'bold'
        },
        ...props.InputLabelProps
      }}
      inputProps={props.inputProps}
    />
  )
}
